/**
 * Public-site navigation links.
 *
 * Single source of truth shared by `PageHeader` and `Footer` — translation
 * happens at render time via `t(key)`.
 */
export const NAV_LINKS = [
    { key: 'nav.home', href: '/', isRoute: true },
    { key: 'nav.about', href: '/#about' },
    { key: 'nav.services', href: '/#service-section' },
    { key: 'nav.prices', href: '/prices', isRoute: true },
    { key: 'nav.gallery', href: '/gallery', isRoute: true },
    { key: 'nav.team', href: '/team', isRoute: true },
    { key: 'nav.contacts', href: '/#contacts' },
];

